import React, {createContext, PropsWithChildren, useContext} from 'react';

export interface SideNavigationProfileProviderProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    profileChild: string | number | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | undefined;
}

const SideNavigationProfileContext = createContext<SideNavigationProfileProviderProps>({profileChild: undefined});

export function SideNavigationProfileProvider({children, profileChild}: PropsWithChildren<SideNavigationProfileProviderProps>) {

    return (
        <SideNavigationProfileContext.Provider value={{profileChild}}>
            {children}
        </SideNavigationProfileContext.Provider>
    );
}

export function useSideNavigationProfileContext() {
    const context = useContext(SideNavigationProfileContext);
    if (context === undefined) {
        throw new Error('SideNavigationProfileContext must be used within a SideNavigationProfileProvider');
    }
    return context;
}